// extracted by mini-css-extract-plugin
export default {"dropdown":"VariantTypeSelection_dropdown__LmOpL"};